import settings from '@/settings'

const pegarHistoricoEmpresa = (payload, headers) => {
  return fetch(`${settings.apetrusApi}/empresas/porposto/?cnpj=${payload.cnpj}&page=${payload.pagination.page}`, {
    method: 'GET',
    mode: 'cors',
    cache: 'default',
    headers: headers
  })
}

export default {
  pegarHistoricoEmpresa
}
